import {
  API_METHOD,
  BASE_URL,
  HOST_URL,
  REQUEST_URL,
} from "../constants/constants";
import { interceptor } from "../interceptor/interceptor";

export const signIn = async (body) => {
  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.url + REQUEST_URL.login,
      data: body,
      contentType: "application/json",
      // headers:{Authorization:`Bearer ${token}`}
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const signUp = async (body) => {
  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.url + REQUEST_URL.register,
      data: body,
      contentType: "application/json",
      // headers:{Authorization:`Bearer ${token}`}
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const OTPVerify = async (body) => {
  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.url + REQUEST_URL.verifyotp,
      data: body,
      contentType: "application/json",
      // headers:{Authorization:`Bearer ${token}`}
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const forgotPassword = async (body) => {
  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.url + REQUEST_URL.forgotpassword,
      data: body,
      contentType: "application/json",
      // headers:{Authorization:`Bearer ${token}`}
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const resetPassword = async (body) => {
  try {
    let response = await interceptor({
      method: API_METHOD.post,
      url: HOST_URL.url + BASE_URL.url + REQUEST_URL.resetpassword,
      data: body,
      contentType: "application/json",
      // headers:{Authorization:`Bearer ${token}`}
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateDetails = async (body,token) => {
    // let token = localStorage.getItem('api-token')

    try {
      let response = await interceptor({
        method: API_METHOD.put,
        url: HOST_URL.url + BASE_URL.url + REQUEST_URL.updateCompanyDetails,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  export const updatePersonalDetails = async (body,token) => {
    // let token = localStorage.getItem('api-token')

    try {
      let response = await interceptor({
        method: API_METHOD.put,
        url: HOST_URL.url + BASE_URL.url + REQUEST_URL.updatePersonalDetails,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };
  

  export const updatePassword = async (body) => {
    let token = localStorage.getItem('api-token')

    try {
      let response = await interceptor({
        method: API_METHOD.post,
        url: HOST_URL.url + BASE_URL.url + REQUEST_URL.updatePassword,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

export const userDetails = async (body) => {
    let token = localStorage.getItem('api-token')
    try {
      let response = await interceptor({
        method: API_METHOD.get,
        url: HOST_URL.url + BASE_URL.url + REQUEST_URL.details,
        // data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  export const licencePurchase = async (body,token) => {
    // let token = localStorage.getItem('api-token')
    console.log('licencePurchased')

    try {
      let response = await interceptor({
        method: API_METHOD.post,
        url: HOST_URL.url + BASE_URL.licenceUrl + REQUEST_URL.purchase,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  export const paymentRequest = async (body,token) => {
    // let token = localStorage.getItem('api-token')
    console.log('licencePurchased')

    try {
      let response = await interceptor({
        method: API_METHOD.post,
        url: HOST_URL.url + BASE_URL.licenceUrl + REQUEST_URL.paymentRequested,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  export const updateLicencePurchase = async (body,token) => {
    // let token = localStorage.getItem('api-token')
    console.log(body,'licencePurchased')

    try {
      let response = await interceptor({
        method: API_METHOD.post,
        url: HOST_URL.url + BASE_URL.licenceUrl + REQUEST_URL.updatePaymentDetails,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };


  export const startDemo = async (body) => {
    console.log('demostarted')
    let token = localStorage.getItem('api-token')
    try {
      let response = await interceptor({
        method: API_METHOD.post,
        url: HOST_URL.url + BASE_URL.url + REQUEST_URL.startDemo,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  export const resendOtpCall = async (body,token) => {
    console.log('demostarted')
    // let token = localStorage.getItem('api-token')
    try {
      let response = await interceptor({
        method: API_METHOD.post,
        url: HOST_URL.url + BASE_URL.url + REQUEST_URL.resendOtp,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  export const inviteEmployee = async (body) => {
    console.log('demostarted')
    let token = localStorage.getItem('api-token')
    try {
      let response = await interceptor({
        method: API_METHOD.post,
        url: HOST_URL.url + BASE_URL.url + REQUEST_URL.resendEmail,
        data: body,
        contentType: "application/json",
        headers:{Authorization:`Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  };
  


  
  
  